/**
 * Footer Menus
 *
 * Handles toggling the footer menus on small screens
 */
(function($) {
	var footer_menus = $( ".site-footer .js-toggle-menu" );

	footer_menus.on(
		"click", function() {
			var menu = $( this );

			if (menu.hasClass( "open" )) {
				menu.removeClass( "open" );
				menu.addClass( "closed" );
			} else {
				menu.addClass( "open" );
				menu.removeClass( "closed" );
			}
		}
	);
})( jQuery );
